import _styled from "styled-components";
import { graphql, useFragment, type FragmentType } from "~/gql/runtime";
import { Link } from "~/features/ui/link";
import { takeFirst } from "~/features/app/utils";
import { isLinkValid } from "~/features/ui/link/utils";
const fragment = graphql(`
  fragment LandingNavAdditionalLink on navAdditionalLinks_link_BlockType {
    link: baseLink {
      ...Link
    }
  }
`);
export function NavAdditionalLink(props: FragmentType<typeof fragment>) {
  const {
    link: _link,
    ...rest
  } = useFragment(fragment, props);
  const link = takeFirst(_link);
  if (!isLinkValid(link)) {
    return null;
  }
  return <_StyledLink {...link} {...rest} $_css={[{
    "position": "relative",
    "display": "inline-flex",
    "height": "100%",
    "width": "100%",
    "alignItems": "center",
    "justifyContent": "center",
    "paddingLeft": "5.2rem",
    "paddingRight": "5.2rem"
  }, {
    "&::before": {
      "content": "var(--tw-content)",
      "position": "absolute",
      "left": "0",
      "right": "0",
      "top": "0",
      "height": "0.4rem",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(75 46 248 / var(--tw-bg-opacity))",
      "opacity": "0",
      "transitionProperty": "opacity",
      "transitionDuration": "250ms",
      "transitionTimingFunction": "ease-in-out",
      "--tw-content": "''"
    }
  }, {
    "@media (hover: hover)": {
      "&:hover::before": {
        "content": "var(--tw-content)",
        "opacity": "1"
      }
    }
  }]} />;
}
var _StyledLink = /*#__PURE__*/_styled(Link).withConfig({
  displayName: "nav-additional-link___StyledLink",
  componentId: "sc-3ukdlj-0"
})(["", ""], p => p.$_css);